function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React, { Component } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { startCheckingSession } from '../../actions/user';
import withWait from './with-wait';
const withCheckSession = (SubComponent, mandatory) => {
  const SubComponentWithWait = withWait(SubComponent, mandatory);
  const WithCheckSession = class extends Component {
    componentDidMount() {
      this.props.startCheckingSession();
    }
    render() {
      const {
        startCheckingSession,
        accessToken,
        accessTokenLoading,
        accessTokenError,
        ...passThroughProps
      } = this.props;
      return /*#__PURE__*/React.createElement(SubComponentWithWait, _extends({
        loading: accessTokenLoading || !accessTokenError && !accessToken,
        error: accessTokenError,
        isAuthenticated: !!accessToken
      }, passThroughProps));
    }
  };
  WithCheckSession.propTypes = {
    startCheckingSession: PropTypes.func.isRequired,
    accessToken: PropTypes.string,
    accessTokenLoading: PropTypes.bool.isRequired,
    accessTokenError: PropTypes.object
  };
  const mapStateToProps = _ref => {
    let {
      user
    } = _ref;
    return {
      accessToken: user.accessToken,
      accessTokenLoading: user.accessTokenLoading,
      accessTokenError: user.accessTokenError
    };
  };
  const mapDispatchToProps = dispatch => ({
    startCheckingSession: () => dispatch(startCheckingSession())
  });
  return connect(mapStateToProps, mapDispatchToProps)(WithCheckSession);
};
export default withCheckSession;